<button
    [disabled]="isImporting"
    class="upload-cart-csv"
    [ngClass]="customClass"
    [class.upload-cart-csv--toolbar]="borderedToolbar"
    aria-label="Upload a cart"
    (click)="openUploadModal()"
>
    <img
        alt=""
        src="assets/icons/upload-icon.svg"
        class="upload-cart-csv__icon"
    />
    {{ isImporting ? "Importing..." : buttonLabel }}
</button>

<vsf-upload-cart-modal
    [visible]="isModalVisible"
    [consolidatedFeedImport]="consolidatedFeedImport"
    [consolidatedFeedPricingIds]="consolidatedFeedPricingIds"
    (close)="closeUploadModal()"
    (uploadSuccess)="onUploadSuccess($event)"
></vsf-upload-cart-modal>
